import React from 'react';
import axios from 'axios';
import { Table, Input, Button, Collapse, Popover, Popconfirm, message, Spin, Form, DatePicker, Select, Tabs, Modal, List, Card, Statistic, Row, Col } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined, FundViewOutlined, DownloadOutlined, LoadingOutlined, PrinterOutlined, BarcodeOutlined, CarOutlined, ClockCircleOutlined, CheckCircleOutlined, ExclamationCircleOutlined, EnvironmentOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import * as serverconfig from './serverconn';
import * as reactstrp from 'reactstrap';
import ReactToPrint from 'react-to-print';
import {
  Row as ReactstrapRow,
  Col as ReactstrapCol,
} from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import moment from 'moment';
import { primarycolor } from "./primarycolor";

var CryptoJS = require("crypto-js");

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const FormItem = Form.Item;
var token = '';
var bizuserid = '';
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker;

class ReportToPrint extends React.Component {

  state = {
    companyprofile: {},
  };

  componentDidMount() {
    axios.get(serverconfig.backendserverurl + `/api/app_profile/${1}`)
      .then(res => {
        this.setState({
          companyprofile: res.data
        })
      })
  }

  render() {
    return (
      <div style={{ padding: '30px', fontFamily: 'Arial, sans-serif', backgroundColor: 'white' }}>
        {/* Header Section */}
        <div style={{ borderBottom: '3px solid #41B715', paddingBottom: '20px', marginBottom: '30px' }}>
          <ReactstrapRow>
            <ReactstrapCol xs="3" sm="3" lg="3">
              <img height="80" width="100" alt="Logo" src={this.state.companyprofile.company_logo}
                style={{ border: '1px solid #ddd', borderRadius: '5px' }} />
            </ReactstrapCol>
            <ReactstrapCol xs="9" sm="9" lg="9">
              <div style={{ textAlign: 'left' }}>
                <h2 style={{ fontWeight: 'bold', color: '#41B715', margin: '0', fontSize: '24px' }}>
                  {this.state.companyprofile.system_name}
                </h2>
                <p style={{ margin: '5px 0', fontSize: '14px', color: '#666' }}>
                  <strong>Tel:</strong> {this.state.companyprofile.RegisteredPhoneNumber1}
                </p>
                <p style={{ margin: '5px 0', fontSize: '14px', color: '#666' }}>
                  <strong>Email:</strong> {this.state.companyprofile.company_email}
                </p>
                <p style={{ margin: '5px 0', fontSize: '12px', color: '#999' }}>
                  Generated on: {new Date().toLocaleDateString('en-GB')} at {new Date().toLocaleTimeString('en-GB')}
                </p>
              </div>
            </ReactstrapCol>
          </ReactstrapRow>
        </div>

        {/* Report Title */}
        <div style={{ textAlign: 'center', marginBottom: '25px' }}>
          <h2 style={{
            fontWeight: 'bold',
            color: '#333',
            margin: '0',
            fontSize: '20px',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            PACKAGE MOVEMENT REPORT
          </h2>
          <p style={{ fontSize: '14px', color: '#666', margin: '8px 0' }}>
            Period: <strong>{this.props.dateone}</strong> to <strong>{this.props.datetwo}</strong>
          </p>
          <p style={{ fontSize: '12px', color: '#999', margin: '5px 0' }}>
            Total Records: <strong>{this.props.pending_deliveries.length}</strong>
          </p>
        </div>

        {/* Professional Table */}
        <reactstrp.Table bordered hover style={{ fontSize: '11px', backgroundColor: 'white' }}>
          <thead style={{ backgroundColor: '#f8f9fa' }}>
            <tr>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', borderRight: '1px solid #dee2e6', textAlign: 'center' }}>#</th>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>Order No</th>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>Collection Point</th>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>Destination</th>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>Item Type</th>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>Item</th>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>Date</th>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>Status</th>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>Pickup Time</th>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>Delivery Time</th>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>Turnaround Time</th>
              <th style={{ padding: '8px 6px', fontWeight: 'bold' }}>Qty</th>
            </tr>
          </thead>
          <tbody>
            {this.props.pending_deliveries.map(
              (item, index) => (
                <tr key={item.id} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa' }}>
                  <td style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid #dee2e6', fontWeight: '500' }}>{index + 1}</td>
                  <td style={{ padding: '6px', borderRight: '1px solid #dee2e6', fontWeight: '500', color: '#41B715' }}>{item.delivery_number}</td>
                  <td style={{ padding: '6px', borderRight: '1px solid #dee2e6' }}>{item.pickup_point || 'N/A'}</td>
                  <td style={{ padding: '6px', borderRight: '1px solid #dee2e6' }}>{item.destination || 'N/A'}</td>
                  <td style={{ padding: '6px', borderRight: '1px solid #dee2e6' }}>{item.item_type || 'N/A'}</td>
                  <td style={{ padding: '6px', borderRight: '1px solid #dee2e6' }}>{item.item_name || 'N/A'}</td>
                  <td style={{ padding: '6px', borderRight: '1px solid #dee2e6' }}>{item.orig_date || item.date}</td>
                  <td style={{
                    padding: '6px',
                    borderRight: '1px solid #dee2e6',
                    color: item.delivery_status === 'pending' ? '#fa8c16' : item.delivery_status === 'delivered' ? '#52c41a' : '#666',
                    fontWeight: '500',
                    textTransform: 'capitalize'
                  }}>
                    {item.delivery_status}
                  </td>
                  <td style={{ padding: '6px', borderRight: '1px solid #dee2e6' }}>{item.time_of_pickup || 'N/A'}</td>
                  <td style={{ padding: '6px', borderRight: '1px solid #dee2e6' }}>{item.time_of_dropoff || 'N/A'}</td>
                  <td style={{ 
                    padding: '6px', 
                    borderRight: '1px solid #dee2e6',
                    color: item.turn_around_time ? (item.turn_around_time === '00:00:00' ? '#52c41a' : '#1890ff') : '#999',
                    fontWeight: '500'
                  }}>
                    {item.turn_around_time || 'N/A'}
                  </td>
                  <td style={{ padding: '6px', textAlign: 'center' }}>{item.items_total || '0'}</td>
                </tr>
              ))}
          </tbody>
        </reactstrp.Table>

        {/* Footer Section */}
        <div style={{ marginTop: '30px', borderTop: '2px solid #f0f0f0', paddingTop: '15px' }}>
          <ReactstrapRow>
            <ReactstrapCol xs="6" sm="6" lg="6">
              <div style={{ fontSize: '12px', color: '#666' }}>
                <p><strong>Report Summary:</strong></p>
                <p>• Total Deliveries: {this.props.pending_deliveries.length}</p>
                <p>• Successful: {this.props.pending_deliveries.filter(item => item.delivery_status === 'delivered').length}</p>
                <p>• Pending: {this.props.pending_deliveries.filter(item => item.delivery_status === 'pending').length}</p>
              </div>
            </ReactstrapCol>
            <ReactstrapCol xs="6" sm="6" lg="6">
              <div style={{ textAlign: 'right', fontSize: '11px', color: '#999' }}>
                <p>This is a computer-generated report.</p>
                <p>© {new Date().getFullYear()} {this.state.companyprofile.system_name}</p>
                <p>Generated by: Umoja Delivery Management System</p>
              </div>
            </ReactstrapCol>
          </ReactstrapRow>
        </div>
      </div>
    );
  }
}

class PackageMovement extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    pending_deliveries: [],
    pending_deliveries_placeholders: [],
    datarequested: true,
    dateone: '',
    datetwo: '',
    delivery_status: 'All',
    companyprofile: {},
    statistics: {
      total_deliveries: 0,
      delivered_count: 0,
      pending_count: 0,
      total_items: 0,
      unique_destinations: 0,
      unique_pickup_points: 0,
      delivery_success_rate: 0
    }
  };

  componentDidMount() {
    this.compo_loaded()
  }

  // Calculate statistics from delivery data
  calculateStatistics = (deliveries) => {
    if (!deliveries || deliveries.length === 0) {
      this.setState({
        statistics: {
          total_deliveries: 0,
          delivered_count: 0,
          pending_count: 0,
          total_items: 0,
          unique_destinations: 0,
          unique_pickup_points: 0,
          delivery_success_rate: 0
        }
      });
      return;
    }

    // Calculate basic statistics
    const totalDeliveries = deliveries.length;
    const deliveredCount = deliveries.filter(item => item.delivery_status === 'delivered').length;
    const pendingCount = deliveries.filter(item => item.delivery_status === 'pending').length;
    
    // Calculate total items
    const totalItems = deliveries.reduce((sum, item) => {
      const items = parseInt(item.items_total) || 0;
      return sum + items;
    }, 0);

    // Calculate unique destinations and pickup points
    const uniqueDestinations = new Set(deliveries.map(item => item.destination).filter(dest => dest && dest !== 'N/A')).size;
    const uniquePickupPoints = new Set(deliveries.map(item => item.pickup_point).filter(point => point && point !== 'N/A')).size;

    // Calculate delivery success rate
    const deliverySuccessRate = totalDeliveries > 0 ? Math.round((deliveredCount / totalDeliveries) * 100) : 0;

    this.setState({
      statistics: {
        total_deliveries: totalDeliveries,
        delivered_count: deliveredCount,
        pending_count: pendingCount,
        total_items: totalItems,
        unique_destinations: uniqueDestinations,
        unique_pickup_points: uniquePickupPoints,
        delivery_success_rate: deliverySuccessRate
      }
    });
  };

  //get dates
  getLastWeekMondayToToday = () => {
    const today = new Date();

    const day = today.getDay();
    const mondayIndex = (day + 6) % 7;

    const thisWeekMonday = new Date(today);
    thisWeekMonday.setDate(today.getDate() - mondayIndex);

    const lastWeekMonday = new Date(thisWeekMonday);
    lastWeekMonday.setDate(thisWeekMonday.getDate() - 7);

    const formatDate = (date) => {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const yyyy = date.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    };

    return {
      lastWeekMonday: formatDate(lastWeekMonday),
      today: formatDate(today)
    };
  }

  compo_loaded = () => {
    //set dates
    this.setState({ dateone: this.getLastWeekMondayToToday().lastWeekMonday })
    this.setState({ datetwo: this.getLastWeekMondayToToday().today })

    let form_data = new FormData();
    form_data.append('dateone', this.getLastWeekMondayToToday().lastWeekMonday);
    form_data.append('datetwo', this.getLastWeekMondayToToday().today);
    form_data.append('delivery_status', this.state.delivery_status);
    form_data.append('hub', '');

    if (this.getLastWeekMondayToToday().lastWeekMonday === '' || this.getLastWeekMondayToToday().today === '') {
      message.error("Please dates are missing")
    } else {
      this.setState({ datarequested: true })
      this.setState({ pending_deliveries: [] })
      this.setState({ pending_deliveries_placeholders: [] })

      //Now submit sale data to database
      axios.post(serverconfig.backendserverurl + '/customqueries/getumoja_deliveriesreport', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
        .then(res => {
          this.setState({ datarequested: false })
          const deliveries = JSON.parse(res.data.report)
          this.setState({ pending_deliveries: deliveries })
          this.setState({ pending_deliveries_placeholders: deliveries })
          this.calculateStatistics(deliveries)
        })
        .catch(error => console.log(error))
    }

    axios.get(serverconfig.backendserverurl + `/api/app_profile/${1}`)
      .then(res => {
        this.setState({
          companyprofile: res.data
        })
      })
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? primarycolor : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    const columns = [
      {
        title: 'Order No',
        dataIndex: 'delivery_number',
        key: 'id',
        ...this.getColumnSearchProps('delivery_number'),
      },
      {
        title: 'Collection point',
        dataIndex: 'pickup_point',
        key: 'id',
        ...this.getColumnSearchProps('pickup_point'),
      },
      {
        title: 'Destination',
        dataIndex: 'destination',
        key: 'id',
        ...this.getColumnSearchProps('destination'),
      },
      {
        title: 'Delivery Type',
        dataIndex: 'item_type',
        key: 'id',
        ...this.getColumnSearchProps('item_type'),
      },
      {
        title: 'Item',
        dataIndex: 'item_name',
        key: 'id',
        ...this.getColumnSearchProps('item_name'),
      },
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'id',
        ...this.getColumnSearchProps('date'),
      },
      {
        title: 'Delivery status',
        dataIndex: 'delivery_status',
        key: 'id',
        ...this.getColumnSearchProps('delivery_status'),
        render: (text, record) =>
          <p style={{ color: record.delivery_status === "pending" ? "orange" : "green" }}>
            {text}
          </p>
      },
      {
        title: 'Time of pickup',
        dataIndex: 'time_of_pickup',
        key: 'id',
      },
      {
        title: 'Time of delivery',
        dataIndex: 'time_of_dropoff',
        key: 'id',
      },
      {
        title: 'Turnaround Time',
        dataIndex: 'turn_around_time',
        key: 'id',
        render: (text) => (
          <span style={{ 
            color: text ? (text === '00:00:00' ? '#52c41a' : '#1890ff') : '#d9d9d9',
            fontWeight: text ? '500' : 'normal'
          }}>
            {text || 'N/A'}
          </span>
        ),
      },
      {
        title: 'Items total',
        dataIndex: 'items_total',
        key: 'id',
      },
    ];

    if (this.state.datarequested === true) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Spin size="large">
            <div className="content">
              <h3>Loading Package Movement...</h3>
            </div>
          </Spin>
        </div>
      )
    } else {
      return (
        <div>
          <div style={{ display: "none" }}>
            <ReportToPrint
              dateone={this.state.dateone}
              datetwo={this.state.datetwo}
              pending_deliveries={this.state.pending_deliveries}
              ref={el => (this.componentRef = el)} />
          </div>

              {/* Package Movement Statistics */}
              <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                  <Card>
                    <Statistic
                      title="Total Deliveries"
                      value={this.state.statistics.total_deliveries || 0}
                      prefix={<CarOutlined />}
                      valueStyle={{ color: '#1890ff' }}
                    />
                  </Card>
                </Col>
                <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                  <Card>
                    <Statistic
                      title="Delivered"
                      value={this.state.statistics.delivered_count || 0}
                      prefix={<CheckCircleOutlined />}
                      valueStyle={{ color: '#52c41a' }}
                    />
                  </Card>
                </Col>
                <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                  <Card>
                    <Statistic
                      title="Pending"
                      value={this.state.statistics.pending_count || 0}
                      prefix={<ClockCircleOutlined />}
                      valueStyle={{ color: '#fa8c16' }}
                    />
                  </Card>
                </Col>
                <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                  <Card>
                    <Statistic
                      title="Success Rate"
                      value={this.state.statistics.delivery_success_rate || 0}
                      suffix="%"
                      prefix={<ExclamationCircleOutlined />}
                      valueStyle={{ color: '#722ed1' }}
                    />
                  </Card>
                </Col>
                <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                  <Card>
                    <Statistic
                      title="Total Items"
                      value={this.state.statistics.total_items || 0}
                      prefix={<ShoppingCartOutlined />}
                      valueStyle={{ color: '#13c2c2' }}
                    />
                  </Card>
                </Col>
                <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                  <Card>
                    <Statistic
                      title="Destinations"
                      value={this.state.statistics.unique_destinations || 0}
                      prefix={<EnvironmentOutlined />}
                      valueStyle={{ color: '#eb2f96' }}
                    />
                  </Card>
                </Col>
                <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                  <Card>
                    <Statistic
                      title="Pickup Points"
                      value={this.state.statistics.unique_pickup_points || 0}
                      prefix={<EnvironmentOutlined />}
                      valueStyle={{ color: '#f5222d' }}
                    />
                  </Card>
                </Col>
              </Row>

              <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'row' }}>
                <ReactToPrint
                  trigger={() =>
                    <Button type="primary" shape="round" icon={<PrinterOutlined />} size={this.state.size}>
                      Print
                    </Button>
                  }
                  content={() => this.componentRef}
                />
                &nbsp;&nbsp;

                <ExcelFile filename={"Umoja Package Movement - " + this.state.dateone + " to " + this.state.datetwo} element={<Button type='primary' icon={<DownloadOutlined />} >Download excel </Button>}>
                  <ExcelSheet data={this.state.pending_deliveries} name="Package Movement">
                    <ExcelColumn label="Order No" value="delivery_number" />
                    <ExcelColumn label="Collection point" value="pickup_point" />
                    <ExcelColumn label="Destination" value="destination" />
                    <ExcelColumn label="Delivery Type" value="item_type" />
                    <ExcelColumn label="Item" value="item_name" />
                    <ExcelColumn label="Date" value="date" />
                    <ExcelColumn label="Delivery status" value="delivery_status" />
                    <ExcelColumn label="Time of pickup" value="time_of_pickup" />
                    <ExcelColumn label="Time of delivery" value="time_of_dropoff" />
                    <ExcelColumn label="Turnaround Time" value="turn_around_time" />
                    <ExcelColumn label="Items total" value="items_total" />
                  </ExcelSheet>
                </ExcelFile>
              </div>

              <br></br>
              <br></br>

              <Form layout="inline" >
                <FormItem label="Delivery status">
                  <Select
                    placeholder="Delivery status"
                    style={{ width: 200 }}
                    value={this.state.delivery_status}
                    onChange={(val) => { this.setState({ delivery_status: val }) }}
                    showSearch
                    optionFilterProp="children"
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value={"All"}>All </Option>
                    <Option value={'pending'}>Pending</Option>
                    <Option value={'delivered'}>Delivered</Option>
                  </Select>
                </FormItem>

                <FormItem label="Date Range">
                  <RangePicker onChange={(date, dateString) => {
                    this.setState({ dateone: dateString[0] });
                    this.setState({ datetwo: dateString[1] });
                  }} format={dateFormat}
                    placeholder={[this.state.dateone, this.state.datetwo]}
                  />
                </FormItem>

                <FormItem>
                  <Button onClick={() => {
                    let form_data = new FormData();
                    form_data.append('dateone', this.state.dateone);
                    form_data.append('datetwo', this.state.datetwo);
                    form_data.append('delivery_status', this.state.delivery_status);
                    form_data.append('hub', '');

                    if (this.state.dateone === '' || this.state.datetwo === '') {
                      message.error("Please dates are missing")
                    } else {
                      this.setState({ datarequested: true })
                      this.setState({ pending_deliveries: [] })
                      this.setState({ pending_deliveries_placeholders: [] })

                      //Now submit sale data to database
                      axios.post(serverconfig.backendserverurl + '/customqueries/getumoja_deliveriesreport', form_data, {
                        headers: {
                          'content-type': 'multipart/form-data'
                        }
                      })
                        .then(res => {
                          this.setState({ datarequested: false })
                          const deliveries = JSON.parse(res.data.report)
                          this.setState({ pending_deliveries: deliveries })
                          this.setState({ pending_deliveries_placeholders: deliveries })
                          this.calculateStatistics(deliveries)
                        })
                        .catch(error => console.log(error))
                    }
                  }} type="primary" htmlType="button">Search</Button>
                </FormItem>
              </Form>

              <br></br>

              <Form layout="inline" >
                <FormItem label="Filter by pickup">
                  <Search
                    placeholder="Pickup Point"
                    onChange={(value) => {
                      var val = value.target.value
                      if (val !== '' || val !== undefined) {
                        const results_1 = this.state.pending_deliveries.filter((request) => {
                          return String(request.pickup_point).includes(val);
                        });

                        if (results_1.length === 0) {
                          this.setState({ pending_deliveries: this.state.pending_deliveries_placeholders });
                          this.calculateStatistics(this.state.pending_deliveries_placeholders);
                        } else {
                          this.setState({ pending_deliveries: results_1 });
                          this.calculateStatistics(results_1);
                        }
                      } else {
                        this.setState({ pending_deliveries: this.state.pending_deliveries_placeholders });
                        this.calculateStatistics(this.state.pending_deliveries_placeholders);
                      }
                    }}
                    style={{
                      width: 200,
                      margin: 5
                    }}
                  />
                </FormItem>

                <FormItem label="Filter by destination">
                  <Search
                    placeholder="Destination"
                    onChange={(value) => {
                      var val = value.target.value
                      if (val !== '' || val !== undefined) {
                        const results_1 = this.state.pending_deliveries.filter((request) => {
                          return String(request.destination).includes(val);
                        });

                        if (results_1.length === 0) {
                          this.setState({ pending_deliveries: this.state.pending_deliveries_placeholders });
                          this.calculateStatistics(this.state.pending_deliveries_placeholders);
                        } else {
                          this.setState({ pending_deliveries: results_1 });
                          this.calculateStatistics(results_1);
                        }
                      } else {
                        this.setState({ pending_deliveries: this.state.pending_deliveries_placeholders });
                        this.calculateStatistics(this.state.pending_deliveries_placeholders);
                      }
                    }}
                    style={{
                      width: 200,
                      margin: 5
                    }}
                  />
                </FormItem>
              </Form>

              <Table
                columns={columns}
                scroll={{ x: 1000 }}
                pagination={{ showQuickJumper: true, showSizeChanger: true }}
                dataSource={this.state.pending_deliveries}
                bordered
              />
        </div>
      )
    }
  }
}

export default PackageMovement;
